/** @description always include jQuery in this manner in every file where jQuery is used */
/* eslint-disable */
const $ = jQuery.noConflict();

import '@fancyapps/fancybox';
'use strict';
const TruncateTestimonials = {
	/**
	 * @description Cache dom and strings
	 */
	slTestimonialText: '.js-product-testimonials-text',
	slReadMore: '.js-read-more',
	classReadMore: 'js-read-more',
	slPopup: '#product-testimonials-popup',
	slPopupText: '.js-product-testimonials-popup-text',
	slPopupAuthor: '.js-product-testimonials-popup-author',
	slPopupImage: '.js-product-testimonials-popup-image',
	slPopupAuthorText: '.js-product-testimonials-popup-author-text',

	/**
	 * @description Initialize
	 */
	init: function() {
		if(this.slTestimonialText.length > 0) {
			this.createPopup();
			this.truncateText();
			this.bindPopupClose();
		}
	},

	/**
	 * @description Create the hidden div that holds the full original content inside each card
	 */
	createPopup: function() {
		const popupHtml = `
            <div id="product-testimonials-popup" style="display: none;">
                <div class="product-testimonials__popup-content">
                    <div class="product-testimonials__slide-content-block js-product-testimonials-popup-text"></div>
                    <div class="product-testimonials__slide-content-author js-product-testimonials-popup-author">
                        <div class="js-product-testimonials-popup-image"></div>
                        <div class="js-product-testimonials-popup-author-text"></div>
                    </div>
                </div>
            </div>
        `;
		$('body').append(popupHtml);
	},

	/**
	 * @description Truncate testimonial text and create the hidden div with full content
	 */
	truncateText: function() {
		const self = this;
		const LIMIT = 330; // number of characters before "Read More"

		$(this.slTestimonialText).each(function() {
			const $wrap = $(this);
			let $p = $wrap.find('p').first();
			if (!$p.length) $p = $wrap; // fallback if no <p> is found

			// Save ORIGINAL (HTML) content for popup
			const $originalContent = $wrap.closest('.js-testimonial-content').clone();
			const $hiddenDiv = $('<div>', {
				class: 'js-original-content',
				style: 'display:none;',
				html: $originalContent.html()
			});
			$wrap.append($hiddenDiv);

			const fullText = $p.text().trim();
			if (fullText.length <= LIMIT) return; // no truncation needed

			// Cut the text to the defined limit
			let cut = fullText.slice(0, LIMIT);
			const lastSpace = cut.lastIndexOf(' ');
			if (lastSpace > 0) cut = cut.slice(0, lastSpace); // ensure words are not cut in half

			// Display truncated text + …
			$p.text(cut + '… ');

			// Add "Read More" link
			const $readMore = $('<a>', {
				href: '#',
				class: `${self.classReadMore} product-testimonial-read-more`,
				text: 'Read More'
			});

			$p.append($readMore);

			// Bind click event to open the popup with full content
			$readMore.on('click', function(e) {
				e.preventDefault();
				self.openPopup($hiddenDiv);
			});
		});
	},


	/**
	 * @description Open the popup with the original content
	 */
	openPopup: function($hiddenDiv) {
		const $popupText = $(this.slPopupText);
		const $popupAuthor = $(this.slPopupAuthor);
		const $popupImage = $(this.slPopupImage);
		const $popupAuthorText = $(this.slPopupAuthorText);

		if ($popupText.length) {
			// Clear any previous content before appending new content
			this.clearPopupFields(); // Clear existing content

			// Get the full content from the hidden div
			$popupText.html($hiddenDiv.find('.js-product-testimonials-text').html());
			const $testimonialCard = $hiddenDiv.closest('.js-testimonial-content');
			if ($testimonialCard.length) {
				// Append the author, image, and author text to the popup
				$popupAuthor.html($hiddenDiv.find('.js-testimonials-author').html());
				$popupImage.html($hiddenDiv.find('.js-testimonials-image').html());
				$popupAuthorText.html($hiddenDiv.find('.js-testimonials-text').html());
			}
			// Open the popup using Fancybox
			if (typeof $.fancybox !== 'undefined') {
				$.fancybox.open({
					src: this.slPopup,
					type: 'inline',
					opts: {
						touch: false,
						dragToClose: false,
						afterClose: () => this.clearPopupFields()
					}
				});
			}
		}
	},

	/**
	 * @description Clear the popup fields after closing
	 */
	clearPopupFields: function() {
		$(this.slPopupText).html('');
		$(this.slPopupAuthor).html('');
		$(this.slPopupImage).html('');
		$(this.slPopupAuthorText).html('');
	},

	/**
	 * @description Bind click event to close the popup
	 */
	bindPopupClose: function() {
		$(document).on('click', '.fancybox-close-small', () => {
			this.clearPopupFields();
		});
	}
};

export default TruncateTestimonials;
